<template>
  <v-container fluid grid-list-md>
    <v-dialog v-model="imageDialog" max-width="100%" scrollable>
      <v-card class="mx-auto">
        <v-card-title style="font-weight: bold; font-size: 1.5em;">Visualização de imagem</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-img :src="img.src" contain class="grey darken-4"></v-img>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" @click="imageDialog = false">FECHAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <!--Index-->
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">{{translate('table.' + entity + '.title')[1]}}</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-btn color="primary" @click="create" class="mb-4">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <v-layout row>
        <v-flex xs12>
          <div v-if="filteredComments.length > 0">
          <v-card wrap justify-center align-center v-for="item in filteredComments" :key="item.id" class="mb-2">
              <v-card-title style="padding-bottom: 0px; padding-top: 0px" primary-title>
                <div class="body-2">
                  <v-tooltip top>
                    <v-checkbox
                      slot="activator"
                      v-model="item.done"
                      @click.native="editValue(entity,item,translate('table.' + entity + '.title')[0])"
                    ></v-checkbox>
                    <span>Concluído</span>
                  </v-tooltip>
                </div>
                <div class="subheading" style="font-weight: bold; word-break: break-all;">{{item.id_text}}</div>
                <v-menu
                  left
                  nudge-top="8"
                  content-class="elevation-0 menu_content"
                  transition="slide-x-reverse-transition"
                  :offset-x="true"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" absolute right fab small v-model="fab" slot="activator" icon class="mx-0">
                      <v-icon medium>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-tooltip bottom>
                    <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="editItem(item)">
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="dialogDelete(item)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                    <span>Excluir</span>
                  </v-tooltip>
                </v-menu>
              </v-card-title>
              <v-card-text style="padding: 10px">
                <div style="overflow-x: wrap; overflow-wrap: break-word; word-wrap: break-word; hyphens: auto; overflow: auto;" class="checklistDescription" v-html="item.description"></div>
              </v-card-text>
            </v-card>
          </div>
          <div v-else>
            <v-card class="mb-2">
              <v-card-text style="padding: 10px">
                <p class="text-xs-center">{{emptyTable}}</p>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    
    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding: 0px">
          <v-form v-model="valid" @keyup.native.esc="close(400)" ref="form" @keyup.native.ctrl.enter="saveChecklist()">
            <v-layout wrap justify-center align-center>
              <v-text-field class="mx-2" maxlength="190" counter="190"  ref="autofocus" :label="translate('table.' + entity + '.field.id_text')" v-model="editedItem.id_text" :rules="requiredRule(translate('table.' + entity + '.field.id_text'))" @keyup.native.enter="$refs.editor.focus(0)"></v-text-field>
              <v-flex xs12>
                <v-form @keyup.native.esc="modal = false">
                  <v-layout wrap justify-center align-center>
                    <v-flex xs12>
                      <p-text-editor ref="editor" @change="(val) => {this.editedItem.description = val}" :height="'90%'"></p-text-editor>
                      <div class="v-text-field__details">
                        <div class="v-messages theme--light">
                          <div class="v-messages__wrapper"></div>
                        </div>
                        <div v-if="editorLengthLimit <= 100" class="v-counter theme--light" style="font-size: 1.1em;">{{this.editorLengthLimit}}%</div>
                        <div v-else style="text-align: right;">
                          <div class="v-counter theme--light" style="font-size: 1.1em; color: red;">{{this.editorLengthLimit}}%</div>
                          <div class="v-counter theme--light" style="font-size: 1.1em; color: red;">O item excedeu o tamanho limite!</div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="this.editorLengthLimit > 100" class="mx-0" color="primary darken-2" :loading="loading" @click.native="saveChecklist">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
  .menu_content {
    padding: 0 10px 10px 10px;
  }
</style>

<script>
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import imageCompress from '../../mixin/imageCompress'
  import PTextEditor from './../shared/PTextEditor'
  import PConfirm from './../shared/PConfirm'

  export default {
    mixins: [crud, rules, imageCompress],
    components: {
      PConfirm, PTextEditor
    },
    name: 'Checklist',
    props: {
      tasktemplate: {
        type: Object,
        default: function () { return {} }
      }
    },
    data: () => ({
      entity: 'tasktemplate_checklist',
      search: '',
      fab: null,
      imageDialog: false,
      img: ''
    }),
    created () {
      this.items = this.tasktemplate['checklists'] ? this.tasktemplate['checklists'] : []
      this.editedItem = {tasktemplate_id: this.tasktemplate.id, id_text: '', description: ''}
      this.defaultItem = {tasktemplate_id: this.tasktemplate.id, id_text: '', description: ''}
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length)
      setTimeout(() => {
        this.addImageListener(document.querySelectorAll('.checklistDescription'))
      }, 400)
    },
    methods: {
      afterCreate () {
        this.$refs.editor.refresh(500)
      },
      afterEditItem () {
        this.$refs.editor.setValue(this.editedItem.description)
        this.$refs.editor.refresh()
      },
      afterClose () {
        this.$refs.editor.setValue('')
      },
      afterDelete (res) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'checklists',
          responseEvent: 'deleteSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      afterEditValue (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'checklists',
          responseEvent: 'editSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      afterInsert (res) {
        this.$emit('itemsLength', this.items.length)
        setTimeout(() => {
          this.addImageListener(document.querySelectorAll('.checklistDescription'))
        }, 400)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'checklists',
          responseEvent: 'addSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      afterUpdate (res) {
        setTimeout(() => {
          this.addImageListener(document.querySelectorAll('.checklistDescription'))
        }, 400)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'checklists',
          responseEvent: 'editSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      saveChecklist () {
        this.$store.commit('loader/change_dialog', true)
        if (this.editedItem.done !== true) {
          this.editedItem.done = false
        }
        this.editedItem.description = this.$refs.editor.getValue()
        // convertido o comentario agora para base64 para armazenagem no servido
        this.imgsCompressAndBase64(this.editedItem.description).then(res => {
          this.$store.commit('loader/change_dialog', false)
          this.editedItem.description = res
          this.save()
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Erro ao salvar listagem!',
            color: 'error',
            dialog: true
          })
        })
      }
    },
    computed: {
      filteredComments () {
        let fieldSearch = ['id_text', 'done']
        return this.items.filter(i => (
          fieldSearch.some(j => {
            return i[j] ? i[j].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(this.search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) : false
          })
        ))
      },
      editorLengthLimit () {
        const limit = 150000
        if (this.editedItem.description !== null && typeof this.editedItem.description !== 'undefined') return Math.round((this.editedItem.description.length / limit) * 100)
        else return 2
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TemplateChecklist.vue